// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1w7GH","content":"LoadingAlert_content__2s915"};